export default "__VITE_ASSET__69f99abc__"